__turbopack_context__.v({
  "active": "FilterButton-module__QoFHyG__active",
  "blok-big-title": "FilterButton-module__QoFHyG__blok-big-title",
  "blok-subtitle": "FilterButton-module__QoFHyG__blok-subtitle",
  "blok-title": "FilterButton-module__QoFHyG__blok-title",
  "filter-button": "FilterButton-module__QoFHyG__filter-button",
  "indicator": "FilterButton-module__QoFHyG__indicator",
});
